export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  content: string[];
  category: "明星动态" | "行业动态" | "活动报道";
  tags: string[];
  cover: string;
  date: string;
  views: number;
  author: string;
  source: string;
}

export const newsCategories: NewsItem["category"][] = ["明星动态", "行业动态", "活动报道"];

export const newsList: NewsItem[] = [
  {
    id: "summer-music-festival-2026",
    title: "2026 夏日音乐节阵容官宣，三十组艺人集结开唱",
    summary:
      "主办方正式公布本届夏日音乐节完整阵容，涵盖流行、摇滚、说唱与电子四大舞台，规模创历届之最。",
    content: [
      "8 月的第一周，备受期待的夏日音乐节终于官宣完整阵容。本届音乐节共设置四大主题舞台，邀请到三十组来自不同领域的音乐人，覆盖流行、摇滚、说唱与电子等多种风格。",
      "主办方表示，今年特别增设了独立音乐人扶持舞台，为新人提供与知名艺人同台的机会。现场还将设立创意市集与美食街区，打造一站式的夏日娱乐体验。",
      "门票将于本周五中午 12 点开启预售，官方提醒乐迷通过正规渠道购票，谨防黄牛加价。届时色花堂将全程跟进报道，带来第一手现场资讯。",
    ],
    category: "活动报道",
    tags: ["音乐节", "演出", "夏日"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20concert%20stage%20with%20warm%20orange%20spotlights%20and%20crowd%20silhouettes%2C%20abstract%20artistic%20poster%20style%2C%20vibrant%20energetic%20atmosphere&width=800&height=450&seq=news-01&orientation=landscape",
    date: "2026-08-02",
    views: 18420,
    author: "色花堂编辑部",
    source: "色花堂现场",
  },
  {
    id: "new-sci-fi-film-box-office",
    title: "国产科幻新片首周末票房破六亿，口碑持续走高",
    summary:
      "这部筹备三年的科幻电影凭借扎实的特效与动人的故事，成为暑期档最大黑马，观影讨论热度居高不下。",
    content: [
      "上周末上映的国产科幻电影在短短三天内斩获超过六亿元票房，成为今年暑期档最亮眼的黑马。影片凭借扎实的视觉特效和动人的情感叙事，在社交平台引发了广泛讨论。",
      "不少观众表示，影片在宏大世界观之外，更打动人的是对亲情与选择的刻画。导演在采访中透露，团队为打磨细节花费了整整三年时间。",
      "随着口碑持续发酵，多家影院已增加排片。业内分析认为，该片有望冲击年度票房前列。",
    ],
    category: "行业动态",
    tags: ["电影", "票房", "科幻"],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20futuristic%20city%20skyline%20with%20glowing%20neon%20lines%20at%20dusk%2C%20artistic%20cinematic%20illustration%2C%20deep%20contrast%20and%20dramatic%20mood&width=800&height=450&seq=news-02&orientation=landscape",
    date: "2026-07-28",
    views: 24100,
    author: "影评组",
    source: "色花堂影视",
  },
  {
    id: "idol-charity-concert",
    title: "人气偶像团体举办慈善演唱会，善款全部用于儿童艺术教育",
    summary:
      "这场以公益为主题的演唱会吸引了上万名观众到场，所有收益将捐赠给偏远地区的儿童艺术教育项目。",
    content: [
      "昨晚，一支人气偶像团体在城市体育馆举办了以公益为主题的慈善演唱会，现场座无虚席，上万名粉丝共同见证了这一温暖时刻。",
      "演唱会所有门票收益将全部捐赠给偏远地区的儿童艺术教育项目，用于建设音乐教室与美术教室。成员们在台上表示，希望用音乐为更多孩子打开一扇窗。",
      "现场还设置了公益互动区，观众可以写下祝福卡片随物资一同送往受助学校。",
    ],
    category: "明星动态",
    tags: ["公益", "演唱会", "偶像"],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20amber%20stage%20lights%20with%20soft%20bokeh%20particles%20and%20abstract%20hearts%2C%20artistic%20charity%20concert%20poster%20style%2C%20hopeful%20glowing%20mood&width=800&height=450&seq=news-03&orientation=landscape",
    date: "2026-07-25",
    views: 15680,
    author: "色花堂编辑部",
    source: "色花堂娱乐",
  },
  {
    id: "director-new-project-announced",
    title: "知名导演公布新作计划，将挑战现实题材群像剧",
    summary:
      "在从业二十周年之际，这位导演宣布启动全新剧集项目，聚焦普通人的奋斗故事，预计明年开拍。",
    content: [
      "在从业二十周年之际，知名导演在一场小型分享会上公布了自己的最新项目——一部聚焦普通人奋斗故事的群像剧集。",
      "导演表示，这些年收到了许多观众关于现实题材的期待，希望能用更细腻的视角记录这个时代。剧本目前已完成初稿，预计明年正式开拍。",
      "消息公布后，众多演员与编剧在社交平台表达了合作意愿，项目的选角工作也将在年内启动。",
    ],
    category: "行业动态",
    tags: ["剧集", "导演", "现实题材"],
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20warm%20studio%20with%20film%20clapperboard%20silhouette%20and%20soft%20amber%20light%2C%20artistic%20editorial%20illustration%2C%20clean%20modern%20look&width=800&height=450&seq=news-04&orientation=landscape",
    date: "2026-07-21",
    views: 9840,
    author: "行业观察",
    source: "色花堂行业",
  },
  {
    id: "variety-show-season-premiere",
    title: "老牌综艺回归新一季，全新赛制引发全民讨论",
    summary:
      "这档陪伴观众多年的综艺节目推出全新赛制，首期播出后相关话题迅速登上热搜榜前列。",
    content: [
      "时隔一年，这档陪伴观众多年的老牌综艺节目正式回归。新一季在赛制上做了大幅革新，加入了跨组合作与观众实时投票环节。",
      "首期播出后，相关话题迅速登上热搜榜前列，嘉宾之间的化学反应也成为网友津津乐道的看点。",
      "节目组透露，本季还将在多座城市进行线下录制，让更多观众有机会参与其中。",
    ],
    category: "明星动态",
    tags: ["综艺", "热搜", "赛制"],
    cover:
      "https://readdy.ai/api/search-image?query=playful%20colorful%20abstract%20shapes%20with%20orange%20and%20teal%20tones%2C%20modern%20variety%20show%20poster%20style%2C%20fun%20energetic%20graphic%20design&width=800&height=450&seq=news-05&orientation=landscape",
    date: "2026-07-18",
    views: 21300,
    author: "综艺观察",
    source: "色花堂综艺",
  },
  {
    id: "film-festival-opening",
    title: "国际电影节开幕，多部亚洲影片入围主竞赛单元",
    summary:
      "本届电影节迎来多部亚洲作品，题材跨越家庭、悬疑与历史，展现了区域创作的蓬勃活力。",
    content: [
      "本届国际电影节日前正式开幕，主竞赛单元名单中出现了多部亚洲影片的身影，题材跨越家庭、悬疑与历史等多个方向。",
      "评委会主席在开幕致辞中表示，今年的入围作品普遍展现出强烈的人文关怀，令人期待最终评选结果。",
      "电影节期间还将举办多场行业论坛与新人扶持工作坊，色花堂将带来系列现场报道。",
    ],
    category: "活动报道",
    tags: ["电影节", "亚洲电影", "入围"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20entrance%20with%20golden%20spotlights%20and%20abstract%20film%20reel%20motif%2C%20artistic%20festival%20poster%20style%2C%20glamorous%20evening%20mood&width=800&height=450&seq=news-06&orientation=landscape",
    date: "2026-07-14",
    views: 13240,
    author: "色花堂现场",
    source: "色花堂影视",
  },
  {
    id: "actress-return-drama",
    title: "实力派女演员回归小荧屏，新剧聚焦都市女性成长",
    summary:
      "这位久未拍剧的女演员宣布加盟新剧，将在剧中饰演一位在职场与家庭之间寻找平衡的女性。",
    content: [
      "久未出演剧集的一位实力派女演员宣布回归小荧屏，将在一部都市题材新剧中担纲女主角。",
      "据片方介绍，该剧聚焦当代都市女性的成长与选择，力求呈现真实而有温度的生活质感。女演员表示，是被剧本的真诚所打动。",
      "该剧预计在下半年开机，播出平台与档期将在稍后公布。",
    ],
    category: "明星动态",
    tags: ["电视剧", "女演员", "都市"],
    cover:
      "https://readdy.ai/api/search-image?query=soft%20elegant%20city%20window%20with%20warm%20afternoon%20light%20and%20minimal%20interior%2C%20artistic%20lifestyle%20editorial%20illustration%2C%20calm%20refined%20tone&width=800&height=450&seq=news-07&orientation=landscape",
    date: "2026-07-10",
    views: 11250,
    author: "色花堂编辑部",
    source: "色花堂娱乐",
  },
  {
    id: "streaming-platform-annual-plan",
    title: "主流流媒体平台发布年度片单，内容投入再创新高",
    summary:
      "平台一口气公布了数十部新作计划，涵盖剧集、综艺与纪录片，显示出对原创内容的持续加码。",
    content: [
      "一家主流流媒体平台日前举办年度发布会，一口气公布了数十部新作计划，涵盖剧集、综艺与纪录片等多个品类。",
      "平台负责人表示，未来将继续加大对原创内容的投入，同时深化与国际制作团队的合作，为观众带来更多元的选择。",
      "发布会上还透露了多项技术升级计划，包括更高画质的观影体验与更智能的推荐系统。",
    ],
    category: "行业动态",
    tags: ["流媒体", "片单", "原创"],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20grid%20of%20glowing%20screens%20and%20play%20buttons%20in%20warm%20orange%20tones%2C%20modern%20digital%20media%20illustration%2C%20clean%20tech%20aesthetic&width=800&height=450&seq=news-08&orientation=landscape",
    date: "2026-07-06",
    views: 8760,
    author: "行业观察",
    source: "色花堂行业",
  },
  {
    id: "chinese-animation-festival",
    title: "国漫主题展人气爆棚，原创动画短片成最大惊喜",
    summary:
      "为期一周的国漫主题展吸引了大量年轻观众，多部原创短片凭借独特画风收获好评。",
    content: [
      "为期一周的国漫主题展日前落下帷幕，现场展出了大量原创动画作品与周边，吸引了众多年轻观众前来打卡。",
      "其中，多部原创动画短片凭借独特的画风与真挚的故事收获了观众好评，成为本次展览的最大惊喜。",
      "主办方表示，未来将继续为青年创作者搭建展示平台，推动国漫文化的交流与发展。",
    ],
    category: "活动报道",
    tags: ["国漫", "展览", "原创"],
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20hand%20drawn%20animation%20style%20scene%20with%20warm%20sunset%20colors%20and%20stylized%20clouds%2C%20artistic%20anime%20poster%20illustration%2C%20playful%20creative%20mood&width=800&height=450&seq=news-09&orientation=landscape",
    date: "2026-07-02",
    views: 14670,
    author: "色花堂现场",
    source: "色花堂动漫",
  },
  {
    id: "singer-album-release",
    title: "创作歌手时隔三年发片，回归之作主打温暖治愈",
    summary:
      "新专辑收录十二首原创作品，其中多首歌曲的灵感来自歌手的日常旅行与生活观察。",
    content: [
      "一位创作型歌手时隔三年推出全新专辑，回归之作以温暖治愈为主基调，收录了十二首原创作品。",
      "歌手分享道，这张专辑的很多灵感来自近几年的旅行与生活观察，希望能在快节奏的生活里给大家带来一点松弛与慰藉。",
      "专辑上线首日便在多个音乐平台登上热榜，实体唱片也同步开启预售。",
    ],
    category: "明星动态",
    tags: ["音乐", "专辑", "创作"],
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20acoustic%20guitar%20beside%20a%20warm%20window%20with%20plants%20and%20soft%20sunlight%2C%20artistic%20music%20album%20illustration%2C%20gentle%20healing%20atmosphere&width=800&height=450&seq=news-10&orientation=landscape",
    date: "2026-06-28",
    views: 12980,
    author: "音乐组",
    source: "色花堂音乐",
  },
  {
    id: "short-drama-industry-report",
    title: "微短剧市场持续升温，行业报告揭示创作新趋势",
    summary:
      "最新报告显示微短剧用户规模稳步增长，竖屏叙事与轻喜剧题材成为当下热门方向。",
    content: [
      "一份最新发布的行业报告显示，微短剧用户规模持续稳步增长，内容形态与商业模式也在不断演进。",
      "报告指出，竖屏叙事、轻喜剧题材以及强节奏的开场设计成为当下热门方向，同时观众对内容质量的要求也在提高。",
      "业内人士认为，随着规范化的推进，微短剧将从野蛮生长走向精品化发展阶段。",
    ],
    category: "行业动态",
    tags: ["微短剧", "行业报告", "趋势"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20vertical%20phone%20screens%20glowing%20with%20colorful%20video%20frames%2C%20warm%20orange%20accent%20tones%2C%20modern%20digital%20media%20illustration&width=800&height=450&seq=news-11&orientation=landscape",
    date: "2026-06-24",
    views: 7640,
    author: "行业观察",
    source: "色花堂行业",
  },
  {
    id: "awards-ceremony-preview",
    title: "年度影视盛典进入倒计时，提名名单引发广泛猜测",
    summary:
      "本届影视盛典的提名名单即将揭晓，多部口碑佳作被认为是最佳影片的有力竞争者。",
    content: [
      "一年一度的影视盛典进入倒计时，主办方透露提名名单将于下周正式公布，引发影迷广泛猜测。",
      "从今年的作品表现来看，多部口碑佳作被认为是最佳影片的有力竞争者，演员奖项的角逐同样激烈。",
      "盛典当晚将进行全程直播，色花堂将带来红毯与后台的独家图文报道，敬请关注。",
    ],
    category: "活动报道",
    tags: ["颁奖礼", "提名", "盛典"],
    cover:
      "https://readdy.ai/api/search-image?query=glamorous%20golden%20trophy%20with%20sparkling%20bokeh%20and%20dark%20elegant%20backdrop%2C%20artistic%20awards%20ceremony%20poster%20illustration%2C%20luxurious%20celebration%20mood&width=800&height=450&seq=news-12&orientation=landscape",
    date: "2026-06-20",
    views: 10320,
    author: "色花堂编辑部",
    source: "色花堂影视",
  },
];